import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import MetricsTableComponent from './../Components/MetricsTableComponent.jsx';
import {
  highlightBar,
  modal as modalActions
} from './../actions';
import {
  getMetricsTableData,
  getBaselineBuildInfo,
  getBaselineBuildNumberByImage,
  getCcfNcfBuildPageOrder,
  getShowSources
} from './../reducers';
import { modals as modalHelpers } from './../helpers';

export const mapStateToProps = (state) => {
  return {
    metrics: getMetricsTableData(state),
    showSources: getShowSources(state),
    isExpectedBaseline: getBaselineBuildInfo(state).buildType === 'Expected',
    baselineBuildNumberByImage: getBaselineBuildNumberByImage(state),
    ccfNcfBuildOrder: getCcfNcfBuildPageOrder(state),
    clickableDiff: true
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    highlightBar: image => dispatch(highlightBar(image)),
    onHitCountClick: (metric, isCcf) => dispatch(
      modalActions.showArtifactHitCountModal(true, metric, isCcf)
    ),
    openConfirm: (metric, ccfNcfBuildOrder, showSources) => {
      if (!metric || !metric.scanKey) {
        toastr.info('Cannot launch modal: unable to determine metric\'s scanKey');
        return;
      }

      const typesChecked = modalHelpers.getTypesChecked(ccfNcfBuildOrder, showSources);
      dispatch(modalActions.showJiraConfirmModal(true, [metric.scanKey], typesChecked));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MetricsTableComponent);


// WEBPACK FOOTER //
// src/Containers/MetricsTableContainer.jsx